module.exports = __webpack_public_path__ + "static/img/swiper3.2dec317.png";


//////////////////
// WEBPACK FOOTER
// ./static/swiper3.png
// module id = +WOh
// module chunks = 1